<template>
    <ui-sidepage extra-large :close="close" :title='`Task Cost Breakdown`' :go-transparent="true">
        <estimate-cost-list-breakdowns :breakdown="breakdown"
                                       @change="(e) => breakdown=e"></estimate-cost-list-breakdowns>
        <hr/>
        <div class="border-gray-200 border rounded-xl bg-white hover:bg-gray-50">
            <estimate-cost-list-title :label="'Estimate'"
                                      :greyed="true"
                                      :title="estimate.title"
                                      @click="goEstimate(estimate)"
                                      :type="'Section'"
                                      :breakdown="breakdown"
                                      @changeBreakdown="(b) => {breakdown=b;goEstimate(estimate)}"
            ></estimate-cost-list-title>
            <div class="ml-4 border-gray-200 border rounded-xl bg-white hover:bg-gray-50 mb-4 ">
                <estimate-cost-list-title :label="'Section'"
                                          :greyed="true"
                                          :title="section.title"
                                          @click="goSection(section,estimate)"
                                          :type="'Task'"
                                          :breakdown="breakdown"
                                          @changeBreakdown="(b) => {breakdown=b;goSection(section,estimate)}"
                ></estimate-cost-list-title>
                <div class="ml-4 border-gray-200 border rounded-xl bg-blue-50 mb-4">
                    <estimate-cost-list-title :label="'Task'"
                                              class="bg-blue-50"
                                              :title="task.reference+' • '+ task.name"
                                              @click="goTask(task,section,estimate)"
                                              :type="'Item'"
                                              :breakdown="breakdown"
                                              @changeBreakdown="(b) => breakdown=b"
                    ></estimate-cost-list-title>
                    <div v-if="breakdown.perItem">
                        <div v-if="task.items.length === 0"
                             class="rounded-b-xl m-0 bg-gray-50 border-gray-200 border-t p-4 text-gray-500 italic text-center">
                            No Items
                        </div>
                        <div v-else class="ml-4">
                            <div v-for="(item,index) in task.items" :key="index"
                                 class="border-gray-200 border rounded-xl bg-white hover:bg-gray-100 mb-4">
                                <estimate-cost-list-title :label="'Item'"
                                                          :title="item.reference+' • '+ item.description"
                                                          @click="goItem(item,task,section,estimate)"
                                ></estimate-cost-list-title>
                                <estimate-cost-list-table :estimate="estimate"
                                                          :type="`item`"
                                                          :costData="itemCosts(item)"
                                                          :breakdown="breakdown"
                                                          :store="store"
                                                          @updateMaterial="(e) => updateItem(item,e)"
                                                          @updateLabour="(e) => updateItem(item,null,e)"
                                                          @updateFixedCost="(e) => updateItem(item,null,null,e)"
                                ></estimate-cost-list-table>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <estimate-cost-list-table :estimate="estimate" :costData="taskCosts(task)"
                                                  :type="`task`"
                                                  :store="store"
                                                  :breakdown="breakdown"
                                                  @updateMaterial="(e) => updateTask(task,e)"
                                                  @updateLabour="(e) => updateTask(task,null,e)"
                                                  @updateFixedCost="(e) => updateTask(task,null,null,e)"
                        ></estimate-cost-list-table>
                    </div>
                </div>
            </div>
        </div>

    </ui-sidepage>
</template>

<script>

import {Estimate, EstimateLabourRate, MaterialNew, PackageNew} from '@models';
import EstimateCostListTable from "./EstimateCostListTable.vue";
import EstimateCostListTitle from "./EstimateCostListTitle.vue";
import {modalStore as $modals} from "../../../../stores";
import EstimateCostListBreakdowns from "./EstimateCostListBreakdowns.vue";
import remoteStorage from "../../../../utils/remoteStorage";

export default {
    components: {
        EstimateCostListBreakdowns,
        EstimateCostListTitle,
        EstimateCostListTable,
    },
    props: {
        task: Object,
        section: Object,
        estimate: Object,
        close: Function,
    },
    watch: {},
    data() {
        let data = remoteStorage.getItem('estimate-cost-list-toggles')
        try {
            data = data ? JSON.parse(data) : {}
            if (!data) {
                data = {};
            }
        } catch (e) {
            data = {};
        }
        return {
            store: {
                materials: [],
                package: PackageNew,
                loaded: false
            },
            breakdown: data,
        }
    },
    async mounted() {
        await Promise.all([PackageNew.find(this.estimate.packageReference), MaterialNew.all(), EstimateLabourRate.all()]).then((a) => {
            this.store.package = a[0]
            this.store.materials = a[1]
            this.store.labourRates = a[2]
            this.store.loaded = true
        })
    },
    methods: {
        total() {
            return this.materials.reduce((a, material) => a + (material.cost * material.quantity), 0);
        },
        taskCosts() {
            let result = Estimate.newCollector()
            this.task.items.forEach((ti) => {
                Estimate.buildMapFromItem(ti, result)
            })
            return result
        },
        itemCosts(item) {
            let result = Estimate.newCollector()
            Estimate.buildMapFromItem(item, result)
            return result
        },
        goEstimate(estimate) {
            $modals.open('estimate-cost-list', {estimate})
        },
        goSection(section, estimate) {
            $modals.open('estimate-section-cost-list', {section, estimate})
        },
        goTask(task, section, estimate) {
            $modals.open('estimate-task-cost-list', {task, section, estimate})
        },
        goItem(item, task, section, estimate) {
            $modals.open('estimate-item-cost-list', {item, task, section, estimate})
        },
        updateItem(item, materialValues, labourValues, fixedCostValues) {
            Estimate.updateItemData(item, materialValues, labourValues, fixedCostValues)
            this.estimate.addSnapshot();
            this.estimate.update()
            this.estimate.buildCollectedItems()
        },
        updateTask(task, materialValues, labourValues, fixedCostValues) {
            task.items.forEach((item) => {
                Estimate.updateItemData(item, materialValues, labourValues, fixedCostValues)
            })
            this.estimate.addSnapshot();
            this.estimate.update()
            this.estimate.buildCollectedItems()
        },
    }
}
</script>
